/** 選択肢データ */
let formOptions;
/**
 * マスタデータを取得
 */
export function getFormOptions() {
  if(!formOptions) {
    /** data要素から選択肢のデータセットを取得 */
    const formOptionsDataset = document.getElementById('form_options')?.dataset;
    if(formOptionsDataset) {
      // データセットをJSONパースして変数にセット
      formOptions = Object.fromEntries(
        Object.entries(formOptionsDataset).map(([key, value]) => [key, JSON.parse(value)])
      );
    }
  }
  return formOptions;
}

/**
 * 地域を取得
 */
export function getAreas() {
  return getFormOptions().areas;
}
/**
 * 都道府県を取得
 */
export function getPrefectures() {
  return getFormOptions().prefectures;
}
/**
 * 業種を取得
 */
export function getBusinessTypes() {
  return getFormOptions().businessTypes;
}
/**
 * 開催月を取得
 */
export function getMonths() {
  return getFormOptions().months;
}
/**
 * 開催日数を取得
 */
export function getHoldDays() {
  return getFormOptions().holdDays;
}
/**
 * 特徴を取得
 */
export function getFeatures() {
  return getFormOptions().features;
}
/**
 * 特徴を取得
 */
export function getWorkContents() {
  return getFormOptions().workContents;
}

export default {
  getFormOptions,
  getAreas,
  getPrefectures,
  getBusinessTypes,
  getMonths,
  getHoldDays,
  getFeatures,
  getWorkContents
};